import { Injectable } from '@angular/core';
import {ApiService} from '../../app-common/services/server/api.service';
import {ChatRoomDto, CreateChatRoomRequest} from '../models/createChatRoomRequest';
import {SendChatMessageRequest} from '../models/sendChatMessageRequest';
import {AppStateService, AppWindowState} from '../../app-common/services/appState/app-state.service';
import {LoggerService} from '../../logging/services/logger.service';
import {LogLevel} from '../../logging/data/logLevel';
import {LogSourceType} from '../../logging/data/logSourceType';
import {LogSource} from '../../logging/data/logSource';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  chatRooms: ChatRoomDto[] = [];

  constructor(private apiService: ApiService,
              private appStateService: AppStateService,
              private loggingService: LoggerService) {
    this.appStateService.appWindowStateChange.subscribe((change) => {
      if (change.previousValue === AppWindowState.Loading && change.currentValue === AppWindowState.Main) {
        this.refreshChatRooms();
      }
    });
  }

  refreshChatRooms() {
    this.getMyChatRooms().then(chatRooms => {
      this.chatRooms = chatRooms;
    }).catch(error => {
      console.error(error);
    });
  }

  createChatRoom(chatRoomDto: CreateChatRoomRequest): Promise<any> {
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.ChatService, 'Created chat room!');
    return this.apiService.applicationApiClient.post('Chat/CreateChatRoom', chatRoomDto);
  }

  sendChatMessage(chatMessageDto: SendChatMessageRequest): Promise<any> {
    this.loggingService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.ChatService, 'Sent a message.');
    return this.apiService.applicationApiClient.post('Chat/SendChatMessage', chatMessageDto);
  }

  private getMyChatRooms(): Promise<ChatRoomDto[]> {
    return this.apiService.applicationApiClient.get('Chat/GetMyChatRooms');
  }
}
